import { render } from "./SaludTrainingPeaks.vue?vue&type=template&id=429962a7&scoped=true"
import script from "./SaludTrainingPeaks.vue?vue&type=script&lang=js"
export * from "./SaludTrainingPeaks.vue?vue&type=script&lang=js"

import "./SaludTrainingPeaks.vue?vue&type=style&index=0&id=429962a7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-429962a7"]])

export default __exports__